import { render } from "./FatButton.vue?vue&type=template&id=04c111ca&scoped=true&ts=true"
import script from "./FatButton.vue?vue&type=script&lang=ts"
export * from "./FatButton.vue?vue&type=script&lang=ts"

import "./FatButton.vue?vue&type=style&index=0&id=04c111ca&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c111ca"]])

export default __exports__